export default __webpack_public_path__ + "static/media/pic2.7a598aab.png";